import { APIResponse } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import { CronValidationResponse } from "./model/validators/types";

class ValidatorsApiDefinition extends ApiDefinition {
  constructor() {
    super("/utils/validators");
  }

  async getCronValidation(expression: string): Promise<APIResponse<CronValidationResponse>> {
    return this.get("quartz-cron", { params: { exp: expression } });
  }
}

const ValidatorsApi = new ValidatorsApiDefinition();
export default ValidatorsApi;
